@if (right || arrowUp || arrowDown) {
  <span class="tutorial-arrow tutorial-arrow-left icon-arrow-{{ arrowUp ? 'up' : arrowDown ? 'down' : 'left' }}"></span>
}

<div class="tutorial-content" [class.center-text]="center" (click)="nextTutorialStep()">
  <h2 class="tutorial-title" [class.large]="largeTitle">{{ title }}</h2>

  <div class="tutorial-body">
    <ng-content></ng-content>
  </div>

  <div class="tutorial-actions">
    @if (!noSteps) {
      <span class="tutorial-previous" (click)="previousTutorialStep($event)">&lt; Previous</span>
      <span class="tutorial-dismiss" (click)="dismissTutorial()">Dismiss All</span>
      <span class="tutorial-position">({{ currentTutorialStepIndex + 1 }}/{{ totalTutorialSteps }})</span>
      <span class="tutorial-next"><h3>@if (currentTutorialStepIndex === totalTutorialSteps - 1) { Finish } @else { Next } ></h3></span>
    } @else {
      <span class="tutorial-position">({{ currentTutorialStepIndex + 1 }}/{{ totalTutorialSteps }})</span>
    }
  </div>
</div>

@if (left && !arrowUp && !arrowDown) {
  <span class="tutorial-arrow tutorial-arrow-right icon-arrow-right"></span>
}
